import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { FormLabel, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useRecoilState } from "recoil";
import { historyFilterAtom } from "../../atoms/atoms";

export default function AuditorFilter({ data, setFilterDataset }) {
  const [auditors, setAuditors] = React.useState([]);
  const [historyFilters, setHistoryFilters] = useRecoilState(historyFilterAtom);
  React.useEffect(() => {
    const uniqueAuditors = new Set(data.map((d) => d.auditor));
    setAuditors(Array.from(uniqueAuditors));
  }, [data]);

  function onChange(newValue) {
    setHistoryFilters((prev) => ({
      ...prev,
      auditor: newValue,
      filtered: true,
    }));
    // if (newValue !== null) {
    //   const filteredData = data.filter((d) => {
    //     return d.auditor === newValue;
    //   });
    //   setFilterDataset(filteredData);
    // } else {
    //   setFilterDataset(data);
    // }
  }

  return (
    <Stack sx={{ width: "33%" }}>
      <Typography variant="overline">Filter by Auditor</Typography>
      <Autocomplete
        sx={{ background: "white" }}
        options={auditors}
        id="controlled-demo"
        value={historyFilters.auditor}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        renderInput={(params) => {
          return <TextField {...params} label="Auditor" />;
        }}
      />
    </Stack>
  );
}
